import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createHomeWorkThunk,
  fetchTeacherHomework,
  getHomeWorkByFiltersThunk,
  updateHomeWorkThunk,
} from "./redux/topicReducer";
import { closeHwPopup } from "./redux/topicSlice";
import { setStepIndex, setStepValid } from "../../../redux/globalJoyrideSlice";
import { getSyllabusScheduleThunk } from "../redux/syllabusthunk";

const HomeWorkForm = () => {
  const dispatch = useDispatch();
  const { popupInfo } = useSelector((state) => state.topic);
  const { syllabusSchedule } = useSelector((state) => state.syllabus);
  const { teacherDetails } = useSelector((state) => state.teachers);
  const [details, setDetails] = useState("");
  const existingHomework = popupInfo?.existingHomework;

  const isEdit = !!existingHomework;
  // useEffect(() => {
  //   if (popupInfo) {
  //     const filters = {
  //       chapter: popupInfo.chapter,
  //       period_number: popupInfo.period_number,
  //       subject_id: popupInfo.subject_id,
  //       class_id: popupInfo.class_id,
  //       section_id: popupInfo.section_id,
  //       teacherId: teacherDetails?.teacher_id
  //     };
  //     dispatch(getHomeWorkByFiltersThunk(filters));
  //   }
  // }, [popupInfo]);

  useEffect(() => {
    if (existingHomework) {
      setDetails(existingHomework.details || "");
    } else {
      setDetails("");
    }
  }, [existingHomework]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      syllabusScheduleId: popupInfo.schedule_id,
      title: details,
      teacherId: teacherDetails.teacher_id
    };

    try {
      if (isEdit) {

        await dispatch(
          updateHomeWorkThunk({
            id: existingHomework?.id,
            details,
          })
        ).unwrap();

        alert("Homework updated successfully!");
      } else {
        await dispatch(createHomeWorkThunk(payload)).unwrap();

        alert("Homework created successfully!");
      }

      // ✅ MAIN FIX — refetch BOTH
      await Promise.all([
        dispatch(
          fetchTeacherHomework({
            teacher_id: popupInfo.teacher_id,
            school_id: popupInfo.school_id || 1,
          })
        ),
        dispatch(getSyllabusScheduleThunk(popupInfo.teacher_id))
      ]);

      // ✅ close AFTER refresh
      dispatch(closeHwPopup());

    } catch (error) {
      console.error("Submit failed:", error);
    }

    dispatch(setStepIndex(11));
  };

  return (
    <div className="topic-container">
      <h2 className="topic-header">Homework</h2>
      <form onSubmit={handleSubmit} className="topic-form">
        <div className="topic-form-group">
          <label className="topic-label">Homework Details:</label>
          <textarea
            rows="5"
            value={details}
            onChange={(e) => {
              setDetails(e.target.value)
              dispatch(setStepValid(true))
            }}
            className="topic-textarea"
            placeholder="Enter homework details"
            data-tour="homework-details-step"
          />
        </div>
        <div className="topic-button-group">
          <button type="submit" className="topic-save-button"
            data-tour="homework-save-step"
          >
            {isEdit ? "Update" : "Save"}
          </button>
          <button
            type="button"
            onClick={() => dispatch(closeHwPopup())}
            className="topic-cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default HomeWorkForm;
